import { SignupTrackingConsent } from '@/components/auth/SignupTrackingConsent';
import { VerifySignupForm } from '@/components/auth/VerifySignupForm';

export default function VerifySignupPage() {
  return (
    <div className='bg-slate-50 dark:bg-stone-950 flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <div className='w-full max-w-sm md:max-w-3xl'>
        <VerifySignupForm />
        <SignupTrackingConsent />
      </div>
    </div>
  );
}
